export class GetTaxDocument {
    static readonly type = '[TaxDocument] GetTaxDocument';
}
